import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: '0.5rem 0',
    borderBottom: `1px solid ${theme.palette.common.paleGrey}`,
  },
  container: {
    padding: 0,
  },
  nameCell: {
    padding: '0.2rem 0.3rem 0.2rem 0.4rem',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
  },
  leftCell: {
    padding: '0.2rem 0.3rem 0.2rem 0',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
  },
  centerCell: {
    padding: '0.2rem 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const DocumentItemHeaders = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container spacing={0} className={classes.container}>
        <Grid item lg={1} />
        <Grid item lg={4} className={classes.nameCell}>
          <Typography variant="subtitle2">Name</Typography>
        </Grid>
        <Grid item lg={2} className={classes.leftCell}>
          <Typography variant="subtitle2">Created</Typography>
        </Grid>
        <Grid item lg={2} className={classes.leftCell}>
          <Typography variant="subtitle2">From</Typography>
        </Grid>
        <Grid item lg={2} className={classes.centerCell}>
          <Typography variant="subtitle2">Category</Typography>
        </Grid>
        <Grid item lg={1} className={classes.centerCell}>
          <Typography variant="subtitle2">Actions</Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default DocumentItemHeaders;
